/**
 * L'état d'interaction de l'accueil de l'élève — la part pure de `useStudentHomeState`.
 *
 *  - `trialDismissed` : la croix du bandeau d'essai le masque jusqu'au prochain passage, comme le
 *    `BannerCard` legacy (un état local, perdu au démontage de l'écran) ;
 *  - `notice` : la boîte que « GO ! » ouvre quand il ne fait pas entrer (`<LiveAccessDialog>`).
 */
export type StudentHomeNotice = "not_today" | "payment_blocked"

export type StudentHomeUiState = {
    trialDismissed: boolean
    notice: StudentHomeNotice | null
}

export type StudentHomeUiAction =
    { type: "DISMISS_TRIAL" } | { type: "OPEN_NOTICE"; notice: StudentHomeNotice } | { type: "CLOSE_NOTICE" }

export const initialStudentHomeUiState: StudentHomeUiState = { trialDismissed: false, notice: null }

export function studentHomeUiReducer(state: StudentHomeUiState, action: StudentHomeUiAction): StudentHomeUiState {
    switch (action.type) {
        case "DISMISS_TRIAL":
            return state.trialDismissed ? state : { ...state, trialDismissed: true }
        case "OPEN_NOTICE":
            return state.notice === action.notice ? state : { ...state, notice: action.notice }
        case "CLOSE_NOTICE":
            return state.notice == null ? state : { ...state, notice: null }
    }
}
